import { useTranslation } from "react-i18next";

export function InitialSessionRecovery({ retry }: { retry(): void }) {
  const { t } = useTranslation();
  return (
    <section className="m-auto max-w-md space-y-4 p-6" role="alert">
      <p>{t("session_recovery.failed")}</p>
      <button
        type="button"
        className="rounded border px-4 py-2"
        onClick={retry}
      >
        {t("session_recovery.retry")}
      </button>
    </section>
  );
}
